import { combineReducers } from 'redux'
import app from './app-reducer'
import user from './user-reducer'

const combinedReducers = combineReducers({
  app,
  user,
})

export default combinedReducers
